module.exports = __webpack_public_path__ + "img/manufacturing-and-logistics.bea58841.svg";